package rendering

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.withFrameMillis
import game.GravitarGame

/**
 * Drives the game update loop using Compose's frame clock.
 *
 * Runs a [LaunchedEffect] coroutine that calls [withFrameMillis] each frame,
 * computes the delta time, caps it at 100 ms to prevent large time steps after
 * pauses or focus loss, and invokes [onFrame] with the capped delta.
 *
 * The coroutine is restarted whenever [game] changes.
 *
 * @param game     The active [GravitarGame] instance. Changing this restarts the loop.
 * @param onFrame  Called each frame with the capped delta time in milliseconds.
 */
@Composable
fun GameLoop(game: GravitarGame, onFrame: (deltaMs: Double) -> Unit) {
    LaunchedEffect(game) {
        var lastTime = withFrameMillis { it }
        while (true) {
            val now = withFrameMillis { it }
            val delta = (now - lastTime).toDouble().coerceAtMost(100.0)
            lastTime = now
            onFrame(delta)
        }
    }
}
